import graphql from './graphql';
import { UserListCourses } from './Request';

const mapCourses = courses =>
  courses?.map(course => [
    course.name,
    course?.description,
    course?.Priority?.name,
    course?.CourseCategory.name,
    course?.userCreated.fullName,
    course?.userCreated.photo,
    course?.thumbnail,
    course?.updatedAt,
    course?.isDraft === 'true',
    course?.expirationDate,
    course?.id,
    {
      id: course?.UserCourseStatus.id,
      name: course?.UserCourseStatus.name,
    },
  ]);

const mapCategories = coursesEnterprise => coursesEnterprise.map(category => category.name || '');

export const fetch = async ({ category = null, name = null }) => {
  const promises = [];
  promises.push(UserListCourses({ category, name }));
  promises.push(graphql('CourseCategory_list', 'name', 'query'));

  const data = await Promise.all(promises);
  const courses = mapCourses(data[0]);
  const categories = mapCategories(data[1].CourseCategory_list);

  return { courses, categories };
};

export default { fetch };
